import { Routes, Route } from 'react-router-dom'
import { AuthenticatedTemplate, UnauthenticatedTemplate } from '@azure/msal-react'
import Home from './pages/Home'
import Stats from './pages/Stats'
import LoginPage from './components/LoginPage'

export default function App() {
  return (
    <>
      <AuthenticatedTemplate>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/stats/:code" element={<Stats />} />
        </Routes>
      </AuthenticatedTemplate>
      <UnauthenticatedTemplate>
        <LoginPage />
      </UnauthenticatedTemplate>
    </>
  )
}
